export default {
    
    pass:
    {
       
            password:"סיסמא ישנה",
            newPassword:"סיסמא חדשה",
            newPasswordAgain:"סיסמא חדשה שנית",
            changepass:'החלפת סיסמא',
        
    },
    pos: {
        search: 'חיפוש',
        configuration: 'הגדרות',
        changepass: 'החלפת סיסמא',
        language: 'שפה',
        theme: {
            name: 'מעטפת',
            light: 'בהיר',
            dark: 'כהה',
        },
         dashboard: {
            monthly_revenue: 'Monthly Revenue',
            new_orders: 'New Orders',
            pending_reviews: 'Pending Reviews',
            new_customers: 'New Customers',
            pending_orders: 'Pending Orders',
            order: {
                items: 'by %{customer_name}, one item |||| by %{customer_name}, %{nb_items} items',
            },
            welcome: {
                title: 'Welcome to admin-on-rest demo',
                subtitle: 'This is the admin of an imaginary poster shop. Fell free to explore and modify the data - it\'s local to your computer, and will reset each time you reload.',
                aor_button: 'Admin-on-rest website',
                demo_button: 'Source for this demo',
            },
        },
    },
    resources: {


account: {
            name: 'פירוט עסקאות |||| פירוט עסקאות ',
            fields: {
                products: 'דפי חשבון',
            },

        }

    }
    
};



// WEBPACK FOOTER //
// ./src/i18n/he.js